import React, { createContext, useContext, useState, useCallback } from "react";
import DocumentViewerModal from "@/components/PdfViewerModal";

const Ctx = createContext(null);

export function PdfViewerProvider({ children }) {
  const [state, setState] = useState({
    open: false, title: "", content: null, downloadPath: "", filename: "",
  });

  const openPdf = useCallback((opts) => {
    setState({
      open: true,
      title: opts.title || "Documento",
      content: opts.content || null,
      downloadPath: opts.path || opts.downloadPath || "",
      filename: opts.filename || "",
    });
  }, []);
  const closePdf = useCallback(() => setState((s) => ({ ...s, open: false })), []);

  return (
    <Ctx.Provider value={{ openPdf, closePdf }}>
      {children}
      <DocumentViewerModal {...state} onClose={closePdf} />
    </Ctx.Provider>
  );
}

export const usePdfViewer = () => useContext(Ctx);
